import { render, staticRenderFns } from "./BuyProcess.vue?vue&type=template&id=0dae1421"
import script from "./BuyProcess.vue?vue&type=script&lang=js"
export * from "./BuyProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports